import reportSetting from '@/entities/insights/modal/report-setting/report-setting.vue';
import { CmGroupItem } from '@/shared/model/cm-group-item.model';
import { detectFile, isNullish } from '@/util/ds-util';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
import moment from 'moment';
import type { BriefingResourceItem, IBriefingPage, IResourceModel, IScrapAgent, IScrollPage } from '@/shared/model/briefing-widget.model';
import { Subscription } from 'rxjs';
import WebsocketService from '@/service/websocket.service';
import { convertDate, formatDateAgo } from '@/util/date-util';
import { sortPinnedBriefing } from '@/util/ds-util';
import { DISCOVERY_CONTENT_TYPE } from '@/constants';
import { map2ResourceItem } from '@/util/mapper-utils';
import RecapService from '@/service/recap.service';
import { checkIsGuestAccount } from '@/util/guest-util';

const groupsManagerStore = namespace('groupsManagerStore');
const briefingStore = namespace('briefingStore');
const appStoreState = namespace('appStore');
@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
    'report-setting': reportSetting,
  },
  methods: {
    convertDate,
    formatDateAgo,
    isNullish,
    detectFile,
  },
})
export default class MyBriefingSidebar extends Vue {
  loaderDisable = false;
  isFullRecommendPages = false;
  public briefingPages: IBriefingPage[] = [];
  public briefingPagesPinned: IBriefingPage[] = [];
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  tempUserKey = JSON.parse(localStorage.getItem('localStorageUser')).id || this.$store.getters?.userIdentity?.id;
  @groupsManagerStore.Getter
  public getGroups!: Array<CmGroupItem>;
  @groupsManagerStore.Action
  public updateImageURLMapInGroup: (payload: { group: CmGroupItem }) => Promise<any>;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (isShowCreateBriefing: boolean) => void;

  @briefingStore.Mutation
  public setBriefingPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setCompanyPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setBriefingAgentsPinned: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setTotalBriefingPages: (totalBriefingPage: number) => void;

  @briefingStore.Mutation
  public setTotalBriefingPagesPinned: (totalBriefingPage: number) => void;

  @briefingStore.Getter
  public getTotalBriefingPagesPinned: number;

  @briefingStore.Mutation
  public setRecommendationPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Getter
  public getBriefingPages!: IBriefingPage[];

  @briefingStore.Getter
  public getCompanyPages!: IBriefingPage[];

  @briefingStore.Getter
  public getBriefingAgentsPinned!: IBriefingPage[];

  @briefingStore.Getter
  public getSocialPages!: IBriefingPage[];

  @briefingStore.Mutation
  public setSelectedSocialPage: (payload: any) => void;

  @briefingStore.Getter
  public getRecommendationPages!: IBriefingPage[];

  @briefingStore.Action
  public updatePinBriefing!: ({ bpId, isPin }: { bpId: string; isPin: boolean }) => Promise<void>;

  @briefingStore.Mutation
  public setSelectedBriefingPage: (payload: any) => void;

  @appStoreState.Mutation
  public setIsShowUpdateBriefing!: (isShowUpdateBriefing: boolean) => void;

  @appStoreState.Getter
  public getIsShowSuccessUpdateBriefing!: boolean;

  @appStoreState.Mutation
  public setIsShowSuccessUpdateBriefing!: (isShowUpdateBriefing: boolean) => void;

  @briefingStore.Mutation
  public setSelectedUpdatingBriefingPage: (payload: any) => void;

  @appStoreState.Getter
  public getIsShowUpdateBriefing!: boolean;

  @appStoreState.Getter
  public getBpIdForReportWithBriefing!: string;

  @appStoreState.Mutation
  public setBpIdForReportWithBriefing!: (payload: string) => void;

  @briefingStore.State('scrollMyBriefingPage')
  private scrollMyBriefingPage!: IScrollPage;

  @briefingStore.State('deleteBriefingPageInList')
  private deleteBriefingPageInList!: boolean;

  @briefingStore.State('selectedBriefingPage')
  private selectedBriefingPage!: IBriefingPage;

  @appStoreState.Mutation
  public setChatSetting!: (payload: any) => void;

  @briefingStore.Mutation
  private setScrollMyBriefingPage: (payload: IScrollPage) => void;

  @briefingStore.Getter
  private getScrollMyBriefingPage!: IScrollPage;

  @briefingStore.Getter
  public getSelectedBriefingPage!: IBriefingPage;

  @briefingStore.Mutation
  public setCheckCallApiMyBP!: (payload: boolean) => void;

  @briefingStore.Getter
  public getCheckCallApiMyBP!: boolean;

  @briefingStore.Getter
  public getCreateBriefing!: boolean;

  @briefingStore.Getter
  public getDeleteBriefingPageInList!: any;

  @briefingStore.Mutation
  public setCreateBriefing: (payload: boolean) => void;

  @briefingStore.Mutation
  public setDeleteBriefingPageInList!: (payload: any) => void;

  @briefingStore.Getter
  public getIsPinInBriefingList!: boolean;

  @briefingStore.Getter
  public getCheckScopeBriefingPage!: string;

  @briefingStore.Getter
  public getTotalBriefingPages!: number;

  @briefingStore.Getter
  public getTotalSubscribeBriefing!: number;

  @briefingStore.Mutation
  public setIsPinned: (payload: boolean) => void;

  @briefingStore.Getter
  public getIsPinned!: boolean;

  @briefingStore.Getter
  public getTotalSubscribeCompany!: number;

  @briefingStore.Getter
  public getBriefingNotFound!: boolean;

  @briefingStore.Mutation
  public setBriefingNotFound!: (payload: any) => void;

  @appStoreState.Mutation
  public setShowAddReference!: (isShowAddReference: boolean) => void;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @briefingStore.Mutation
  public setIsForNewBriefing!: (payload: boolean) => void;

  @briefingStore.Mutation
  public setSocialPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Getter
  public getSelectedSocialPage!: IBriefingPage;

  @briefingStore.Mutation
  public setCheckCallApiSubBP: (payload: boolean) => void;

  @briefingStore.Mutation
  public setCheckCallApiCompanyBP: (payload: boolean) => void;

  @briefingStore.Getter
  public getCheckCallApiCompanyBP!: boolean;

  @briefingStore.Mutation
  public setFeaturedPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setFeaturedCompanies: (payload: IResourceModel[]) => void;

  @briefingStore.Getter
  public getScrollSubscribeBriefingPage!: IScrollPage;

  @briefingStore.Mutation
  public setScrollSubscribeCompanyPage: (payload: IScrollPage) => void;

  @briefingStore.Getter
  public getScrollSubscribeCompanyPage!: IScrollPage;

  @briefingStore.Mutation
  public setTotalSubscribeBriefing: (payload: number) => void;

  @briefingStore.Mutation
  public setTotalSubscribeCompany: (payload: number) => void;

  @briefingStore.Mutation
  public setScrollSubscribeBriefingPage: (payload: IScrollPage) => void;

  @briefingStore.Getter
  public getCheckCallApiSubBP!: boolean;

  @briefingStore.Mutation
  public setIsSubscribedBriefing: (payload: boolean) => void;

  @briefingStore.Getter
  public isSubscribedBriefing!: boolean;

  @briefingStore.Mutation
  public setDailyBriefingAgent!: (payload: IScrapAgent) => void;

  @briefingStore.Getter
  public getDailyBriefingAgent!: IScrapAgent;

  @briefingStore.Mutation
  public setWeeklyBriefingAgent!: (payload: IScrapAgent) => void;

  @briefingStore.Mutation
  public setNewestRecap!: (payload: any) => void;

  @briefingStore.Getter
  public getWeeklyBriefingAgent!: IScrapAgent;

  @briefingStore.Getter
  public getIsLoadingBriefingWelcome!: boolean;

  private loadingGetRecommendations = true;
  briefingTitleSubscription: Subscription = null;
  briefingRecommendationSubscription: Subscription = null;
  loadMoreAble = true;
  indexShow = 5;
  indexShowSocial = 5;
  indexShowCompany = 5;
  private loadingGetFeaturedBriefing = true;
  socialBriefingPages: IBriefingPage[] = [];
  companyBriefingPages: IBriefingPage[] = [];
  companyAgentFeatured: IResourceModel[] = [];
  isFullSocialPages = false;
  isFullCompanyAgent = false;
  selectedByUrl: IBriefingPage = null;
  checkUser = false;
  loadMore = true;
  totalBriefingPages = 0;
  totalBriefingPagesPinned = 0;
  scrollSettings = {
    wheelPropagation: false,
  };
  weeklyThumbnail: any = null;
  dailyThumbnail: any = null;
  language: string = this.$i18n.locale || localStorage.getItem('currentLanguage');
  contentLanguages: string[] = [];
  socialBriefingPageCheck = 'SOCIAL_BRIEFING_PAGE';
  isAgentsCollapsed = false;
  isSocialCollapsed = false;
  isCompanyCollapsed = false;
  initialPinnedPage = 0;
  loadMorePinnedPage = false;
  indexShowMyBriefingPage = 0;
  loadingPinnedPage = false;

  @Watch('$i18n.locale')
  onLanguageChange(newVal: string) {
    this.language = this.$i18n.locale || localStorage.getItem('currentLanguage');
  }

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @Inject('recapService')
  private recapService: () => RecapService;

  @Inject('websocketService')
  private websocketService: () => WebsocketService;

  @Watch('getIsShowSuccessUpdateBriefing')
  onIsShowSuccessUpdateBriefingChange() {
    if (this.getIsShowSuccessUpdateBriefing) {
      this.handleShowSuccessNotification();
    }
  }

  @Watch('getTotalBriefingPagesPinned')
  onTotalBriefingPagesPinnedChange(newVal) {
    this.totalBriefingPagesPinned = newVal;
  }

  @Watch('getScrollSubscribeBriefingPage')
  async onScrollSubscribeBriefingPageChange(newval: IScrollPage, oldval: IScrollPage) {
    if (newval.currentPage > 0 && newval.currentPage != oldval.currentPage) {
      this.setCheckCallApiSubBP(false);
      await this.getAllSocialBriefingPage(newval.currentPage);
    }
  }

  @Watch('getScrollSubscribeCompanyPage')
  async onScrollSubscribeCompanyPageChange(newval: IScrollPage, oldval: IScrollPage) {
    if (newval.currentPage > 0 && newval.currentPage != oldval.currentPage) {
      this.setCheckCallApiCompanyBP(false);
      await this.getAllCompanyAgent(newval.currentPage);
    }
  }

  @Watch('getIsShowUpdateBriefing')
  onGetIsShowUpdateBriefingChange() {
    if (!this.getIsShowUpdateBriefing) {
      this.setSelectedUpdatingBriefingPage({});
    }
  }

  @Watch('isSubscribedBriefing')
  async onIsSubscribedBriefing(newVal: boolean) {
    if (!newVal) {
      if (this.getSocialPages.length > 5) {
        await this.getSocialBriefingPageBySize(0, this.getSocialPages.length);
        this.indexShowSocial = this.getSocialPages.length;
      } else {
        await this.getAllSocialBriefingPage(0);
      }
      this.setIsSubscribedBriefing(true);
    }
  }

  @Watch('getIsShowSuccessUpdateBriefing')
  onGetIsShowSuccessUpdateBriefingChange() {
    this.setSelectedUpdatingBriefingPage({});
  }

  @Watch('scrollMyBriefingPage')
  async onCurrentPageMyBriefingChange(newVal: IScrollPage, oldVal: IScrollPage) {
    if (this.loadMore && newVal.currentPage !== oldVal.currentPage && newVal.currentPage > 0) {
      if (!this.getCreateBriefing) {
        this.loadMoreAble = false;
        this.setCheckCallApiMyBP(this.loadMoreAble);
        await this.getAllBriefingPage(newVal.currentPage);
      }
    }
  }

  @Watch('$route.params.bpId')
  async onRouteParamChange() {
    const selected = this.briefingPages.find(item => item.bpId === this.$route.params?.bpId);
    if (selected) {
      this.setSelectedBriefingPage(selected);
      this.selectedByUrl = null;
    }
  }

  @Watch('deleteBriefingPageInList')
  async onDeleteBriefingPageInList(newVal: any) {
    if (newVal.isDelete) {
      const oldLength = newVal.length;
      await this.getBriefingPageBySize(0, oldLength < this.totalBriefingPages ? oldLength : this.briefingPages.length);
      this.setDeleteBriefingPageInList({ isDelete: false, length: 0 });
    }
  }

  @Watch('getBriefingNotFound')
  async onGetBriefingNotFound(newVal: any) {
    if (newVal) {
      await this.getBriefingPageRecommendationList();
      this.setBriefingNotFound(false);
    }
  }

  @Watch('$store.getters.userIdentity.id')
  subscribeBriefingTitle(userKey: string): void {
    if (userKey != null || String.prototype.isNullOrEmpty(userKey)) {
      /* subscribe for update title briefing */
      if (this.briefingTitleSubscription) {
        this.briefingTitleSubscription.unsubscribe();
      }
      this.briefingTitleSubscription = this.websocketService().subscribeBriefingTitle(userKey, false, {
        next: (data: any) => {
          const items = data.titleCompleteList;
          for (const item of items) {
            this.getSocialPages.forEach(el => {
              if (el.bpId === item.bpId) {
                el.briefingPageName = item.title;
              }
            });
            this.setSocialPages(this.getSocialPages);
          }
        },
      });
    }
  }

  @Watch('getTotalSubscribeCompany')
  onCompanyPagesChange(newVal: any, oldVal: any) {
    // console.log('getCompanyPages', newVal, oldVal);
    const newValAdd = newVal === oldVal + 1;
    const newValSub = newVal === oldVal - 1;
    if (newValAdd || newValSub) {
      this.setCheckCallApiCompanyBP(false);
      if (this.getCompanyPages.length < 6) {
        this.getAllCompanyAgent(0);
      } else {
        this.getAllCompanyAgentBySize(0, this.getCompanyPages.length);
      }
    }
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  @Watch('$route.params.bpId', { immediate: true })
  onChangeRouteParamBpId(newVal: string) {
    this.changeRouteWithBpId();
  }

  public get isGuest(): boolean {
    return checkIsGuestAccount();
  }

  get uniqueBriefingAgentsPinned() {
    return this.getUniquePages(this.getBriefingAgentsPinned);
  }

  get uniqueSocialBriefingPages() {
    return this.getUniquePages(this.socialBriefingPages);
  }

  private getUniquePages(pages: IBriefingPage[]): IBriefingPage[] {
    if (!pages || !pages.length) {
      return [];
    }

    const seenIds = new Set<string>();
    return pages.filter(page => {
      if (!page.bpId) return false;

      if (seenIds.has(page.bpId)) {
        return false;
      }

      seenIds.add(page.bpId);
      return true;
    });
  }

  async created() {
    this.contentLanguages = this.localStorageUser?.contentLanguages || [this.language];
    // this.changeRouteWithBpId();
    this.getAllBriefingPage(0);
    this.getBriefingPageRecommendationList();
    this.getAllSocialBriefingPage(0);
    this.getFeaturedBriefing();
    this.getAllCompanyAgent(0);
    this.getFeatureCompanyAgent(0);
    this.getAllPinnedBriefingPage();
    if (!this.isGuest) {
      this.getDailyWeeklyThumbnail();
      this.getNewestRecap();
    }
  }

  destroyed(): void {}

  mounted(): void {
    this.onWatchUserIdentityIdChange(this.$store?.getters?.userIdentity?.id);
  }

  @Watch('getBpIdForReportWithBriefing')
  onGetBpIdForReportWithBriefingChange() {
    if (this.getBpIdForReportWithBriefing?.trim()?.length > 0) {
      const intervalClickToBriefing = setInterval(() => {
        const elementBriefing = document.getElementById('element_' + this.getBpIdForReportWithBriefing);

        if (elementBriefing) {
          elementBriefing.click();
          this.setBpIdForReportWithBriefing('');
          clearInterval(intervalClickToBriefing);
        }
      }, 100);

      setTimeout(() => {
        this.setBpIdForReportWithBriefing('');
        clearInterval(intervalClickToBriefing);
      }, 30000);
    }
  }

  viewMoreMyBriefingPage(): void {
    if (this.loadMorePinnedPage) {
      this.getAllPinnedBriefingPage();
    }
    if (this.indexShowMyBriefingPage < this.getBriefingAgentsPinned.length) {
      this.indexShowMyBriefingPage += 5;
    }
  }

  async getAllPinnedBriefingPage() {
    this.loadingPinnedPage = true;
    const pinnedBriefingPagesNumber = 5;
    await this.briefingService()
      .getAllBriefingPage(
        this.$store.getters.userIdentity.id,
        true,
        null,
        this.initialPinnedPage,
        pinnedBriefingPagesNumber,
        null,
        null,
        null,
        null,
        null,
        true
      )
      .then(res => {
        this.indexShowMyBriefingPage += res?.data?.body?.briefingPageList.length;
        this.briefingPagesPinned = [...this.getBriefingAgentsPinned, ...res?.data?.body?.briefingPageList];
        this.setBriefingAgentsPinned(sortPinnedBriefing(this.briefingPagesPinned));
        this.loadMorePinnedPage = res?.data?.body?.loadMore;
        this.totalBriefingPagesPinned = res?.data?.body?.totalBriefingPagesPinned;
        this.setTotalBriefingPagesPinned(this.totalBriefingPagesPinned);
        this.initialPinnedPage++;
        this.loadingPinnedPage = false;
      })
      .catch(error => {
        console.error(error);
        this.loadingPinnedPage = false;
      });
  }

  async getAllBriefingPage(page?: number) {
    if (this.$store?.getters?.userIdentity?.id && !this.getIsPinned) {
      await this.briefingService()
        .getAllBriefingPage(this.$store.getters.userIdentity.id, true, null, page, 30)
        .then(res => {
          this.totalBriefingPages = res.data?.body?.totalBriefingPages;
          this.setTotalBriefingPages(this.totalBriefingPages);
          if (res.data?.body?.briefingPageList && res.data?.body?.briefingPageList?.length > 0) {
            const briefingPageList = res.data?.body?.briefingPageList;
            if (page == 0) {
              this.briefingPages = [...this.briefingPages, ...briefingPageList];
            } else {
              this.briefingPages = [...this.getBriefingPages, ...briefingPageList];
            }

            this.briefingPages.forEach(item => (item.bpType = 'MY_BRIEFING'));
            this.setBriefingPages(this.briefingPages);
            this.loadMoreAble = true;
            this.setCheckCallApiMyBP(this.loadMoreAble);
            this.setCreateBriefing(false);
            this.setScrollMyBriefingPage({ currentPage: page, loadMore: true });
          } else {
            this.setBriefingPages(this.briefingPages);
            this.loadMore = false;
            this.loadMoreAble = false;
            this.setCheckCallApiMyBP(this.loadMoreAble);
            this.setScrollMyBriefingPage({ currentPage: page, loadMore: false });
          }
        })
        .catch(reason => {
          this.loadMore = true;
          this.loadMoreAble = true;
          this.setCheckCallApiMyBP(this.loadMoreAble);
          this.setScrollMyBriefingPage({ currentPage: page, loadMore: true });
          this.setCreateBriefing(false);
        });
    }
  }

  async getBriefingPageBySize(page?: number, pageSize?: number) {
    if (this.$store.getters.userIdentity.id) {
      await this.briefingService()
        .getAllBriefingPage(this.$store.getters.userIdentity.id, true, null, page, pageSize)
        .then(res => {
          this.totalBriefingPages = res.data?.body?.totalBriefingPages;
          this.setTotalBriefingPages(this.totalBriefingPages);
          if (res.data?.body?.briefingPageList && res.data?.body?.briefingPageList?.length > 0) {
            this.briefingPages = res.data?.body?.briefingPageList;
            this.briefingPages.forEach(item => (item.bpType = 'MY_BRIEFING'));
            if (this.getDeleteBriefingPageInList.length > 0 && this.getDeleteBriefingPageInList.length < this.totalBriefingPagesPinned) {
              this.indexShow = this.getDeleteBriefingPageInList.length;
            } else {
              this.indexShow = this.briefingPagesPinned.length;
            }
            this.loadMoreAble = true;
            this.setCheckCallApiMyBP(this.loadMoreAble);
            this.setBriefingPages(this.briefingPages);
          } else {
            this.loadMore = false;
            this.loadMoreAble = false;
            this.setCheckCallApiMyBP(this.loadMoreAble);
          }
        })
        .catch(reason => {
          this.loadMore = true;
          this.loadMoreAble = true;
          this.setCheckCallApiMyBP(this.loadMoreAble);
          return;
        });
    }
  }

  async getAllSocialBriefingPage(page?: number) {
    if (this.$store.getters?.userIdentity?.id && this.getScrollSubscribeBriefingPage.loadMore) {
      await this.briefingService()
        .getSubscribeBriefingPage(null, null, null, page, 5)
        .then(res => {
          if (res.data?.statusCodeValue == 200) {
            const totalSocialBriefingPages = res.data?.body?.body.totalBriefingPages;
            if (res.data?.body?.body?.socialBriefingPageList && res.data?.body?.body?.socialBriefingPageList.length > 0) {
              const socialBriefingPages = res.data?.body?.body?.socialBriefingPageList;
              socialBriefingPages.forEach(item => {
                item.bpType = 'SOCIAL_BRIEFING';
              });
              //tim den dung vi tri thi remove
              const duplicate = this.socialBriefingPages.filter(newItem =>
                socialBriefingPages.some(existingItem => existingItem.bpId === newItem.bpId)
              );
              if (duplicate && duplicate.length > 0) {
                this.socialBriefingPages = this.socialBriefingPages.filter(newItem => newItem.bpId !== duplicate[0].bpId);
              }
              if (page === 0) {
                this.socialBriefingPages = socialBriefingPages;
              } else {
                this.socialBriefingPages = [...this.socialBriefingPages, ...socialBriefingPages];
              }
              //push khi phan tu nam ngoai size
              const isBpIdNotInSocialPages = !this.socialBriefingPages.some(item => item.bpId === this.$route.params.bpId);
              const isValidRoute = ['SocialBriefing-All', 'SocialBriefing-Detail'].includes(this.$route.name);
              const isSubscribe = this.getSelectedSocialPage.subscribeStatus && this.getSelectedSocialPage.subscribeStatus === 'SUBSCRIBE';
              const shouldAddSelectedPage = this.getSelectedSocialPage.bpId && this.$route.params.bpId && isValidRoute;

              if (isBpIdNotInSocialPages && shouldAddSelectedPage && isSubscribe) {
                const isSelectedPageNotIncluded = !this.socialBriefingPages.some(item => item.bpId === this.getSelectedSocialPage.bpId);
                if (isSelectedPageNotIncluded) {
                  this.socialBriefingPages.push(this.getSelectedSocialPage);
                  this.indexShow = this.socialBriefingPages.length;
                }
              }
              this.socialBriefingPages = this.socialBriefingPages.sort(
                (a, b) => new Date(b.subscribedDate).getTime() - new Date(a.subscribedDate).getTime()
              );
              this.setSocialPages(this.socialBriefingPages);
              this.setTotalSubscribeBriefing(totalSocialBriefingPages);
              this.setCheckCallApiSubBP(true);
              const scrollMyBriefingPageList = { currentPage: page, loadMore: true };
              this.setScrollSubscribeBriefingPage(scrollMyBriefingPageList);
            } else {
              this.setSocialPages(this.socialBriefingPages);
              this.setTotalSubscribeBriefing(totalSocialBriefingPages);
              const scrollMyBriefingPageList = { currentPage: page, loadMore: false };
              this.setScrollSubscribeBriefingPage(scrollMyBriefingPageList);
              this.setCheckCallApiSubBP(false);
            }
            // const selected = socialBriefingPages.find(item => item.bpId === this.$route.params.bpId);
            // if (selected) {
            //   this.setSelectedSocialPage(selected);
            // }
          }
        })
        .catch(err => {
          const scrollMyBriefingPageList = { currentPage: page, loadMore: true };
          this.setScrollSubscribeBriefingPage(scrollMyBriefingPageList);
          this.setCheckCallApiSubBP(true);
        });
    }
  }

  getFeatureCompanyAgent(page: number): void {
    this.loadMoreAble = false;
    const documentType = DISCOVERY_CONTENT_TYPE.COMPANY;
    this.briefingService()
      .getHomeBriefingData(
        // @ts-ignore
        documentType,
        null,
        null,
        null,
        this.contentLanguages,
        null,
        null,
        0,
        100,
        null
      )
      .then(resp => {
        // this.loadMoreDiscovery = resp.data.body.body.moreDiscovery;
        // this.loadMoreReport = resp.data.body.body.moreReport;
        if (
          resp.data?.body?.body?.discoveryReportDTO?.listBriefingData &&
          resp.data?.body?.body?.discoveryReportDTO?.listBriefingData.length > 0
        ) {
          const companyBriefingPages = resp.data?.body?.body?.discoveryReportDTO?.listBriefingData;

          // this.companyAgentFeatured = companyBriefingPages.map(item => {
          //   if(item.documentType === 'COMPANY' && item.parentDocDetail?.subscribeStatus === 'UN_SUBSCRIBE'){
          //     return item.parentDocDetail;
          //   }
          // });
          this.companyAgentFeatured = companyBriefingPages
            .filter((item: BriefingResourceItem) => {
              if (item.documentType === 'COMPANY' && item.parentDocDetail?.subscribeStatus === 'UN_SUBSCRIBE') {
                return item.parentDocDetail;
              }
            })
            .map(map2ResourceItem);
          // console.log(this.companyAgentFeatured, '2222222222222222')
          this.setFeaturedCompanies(this.companyAgentFeatured);
        }
        // const briefingData = resp?.data?.body?.body?.discoveryReportDTO?.listBriefingData;
        // const documentTypes = ['DISCOVERY', 'SOCIAL', 'DOCUMENT'];
        // if (filterPayload.documentType.some(type => documentTypes.includes(type))) {
        //   this.sessionIdFeed = resp?.data?.body?.body?.sessionId;
        // } else {
        //   this.sessionIdBriefing = resp?.data?.body?.body?.sessionId;
        // }
        // if (currentPage == 0) {
        //   this.resourceItems = [];
        // }
        // if (!isNullOrEmptyArray(briefingData)) {
        //   this.addMoreDataToResourceList(briefingData);
        // }
        // // this.loadMoreAble = this.loadMoreDiscovery || this.loadMoreReport;
        // this.loadMoreAble = resp?.data?.body?.body?.loadMore;
      })
      .catch(err => {});
  }

  async getAllCompanyAgent(page?: number) {
    if (this.$store.getters?.userIdentity?.id && this.getScrollSubscribeBriefingPage.loadMore) {
      await this.briefingService()
        .getSubscribeCompanyAgent(null, null, null, page, 10)
        .then(res => {
          // console.log(res,'`````````````````````````')
          if (res.data?.statusCodeValue == 200) {
            const totalSocialBriefingPages = res.data?.body?.body.totalBriefingPages;
            if (res.data?.body?.body?.socialBriefingPageList && res.data?.body?.body?.socialBriefingPageList.length > 0) {
              const companyBriefingPages = res.data?.body?.body?.socialBriefingPageList;
              const duplicate = this.companyBriefingPages.filter(newItem =>
                companyBriefingPages.some(existingItem => existingItem.bpId === newItem.bpId)
              );
              if (duplicate && duplicate.length > 0) {
                this.companyBriefingPages = this.companyBriefingPages.filter(newItem => newItem.bpId !== duplicate[0].bpId);
              }
              if (page === 0) {
                this.companyBriefingPages = companyBriefingPages;
              } else {
                this.companyBriefingPages = [...this.companyBriefingPages, ...companyBriefingPages];
              }
              this.companyBriefingPages = this.companyBriefingPages.sort(
                (a, b) => new Date(b.subscribedDate).getTime() - new Date(a.subscribedDate).getTime()
              );
              this.setCompanyPages(this.companyBriefingPages);
              this.setTotalSubscribeCompany(totalSocialBriefingPages);
              //
              this.setCheckCallApiCompanyBP(true);
              const scrollMyBriefingPageList = { currentPage: page, loadMore: true };
              this.setScrollSubscribeCompanyPage(scrollMyBriefingPageList);
            } else {
              //
              this.setCompanyPages(this.companyBriefingPages);
              this.setTotalSubscribeBriefing(totalSocialBriefingPages);
              const scrollMyBriefingPageList = { currentPage: page, loadMore: false };
              this.setScrollSubscribeCompanyPage(scrollMyBriefingPageList);
              this.setCheckCallApiCompanyBP(false);
            }
            // const selected = socialBriefingPages.find(item => item.bpId === this.$route.params.bpId);
            // if (selected) {
            //   this.setSelectedSocialPage(selected);
            // }
          }
        })
        .catch(err => {
          const scrollMyBriefingPageList = { currentPage: page, loadMore: true };
          this.setScrollSubscribeCompanyPage(scrollMyBriefingPageList);
          this.setCheckCallApiCompanyBP(true);
        });
    }
  }

  async getAllCompanyAgentBySize(page?: number, size?: number) {
    if (this.$store.getters?.userIdentity?.id && this.getScrollSubscribeBriefingPage.loadMore) {
      await this.briefingService()
        .getSubscribeCompanyAgent(null, null, null, page, size)
        .then(res => {
          // console.log(res,'`````````````````````````')
          if (res.data?.statusCodeValue == 200) {
            const totalSocialBriefingPages = res.data?.body?.body.totalBriefingPages;
            if (res.data?.body?.body?.socialBriefingPageList && res.data?.body?.body?.socialBriefingPageList.length > 0) {
              const companyBriefingPages = res.data?.body?.body?.socialBriefingPageList;
              this.companyBriefingPages = companyBriefingPages;
              this.companyBriefingPages = this.companyBriefingPages.sort(
                (a, b) => new Date(b.subscribedDate).getTime() - new Date(a.subscribedDate).getTime()
              );
              this.setCompanyPages(this.companyBriefingPages);
              this.setTotalSubscribeCompany(totalSocialBriefingPages);
              this.setCheckCallApiCompanyBP(true);
              const scrollMyBriefingPageList = { currentPage: page, loadMore: true };
              this.setScrollSubscribeCompanyPage(scrollMyBriefingPageList);
              this.indexShowCompany = size;
            } else {
              //
              this.setCompanyPages(this.companyBriefingPages);
              this.setTotalSubscribeBriefing(totalSocialBriefingPages);
              const scrollMyBriefingPageList = { currentPage: page, loadMore: false };
              this.setScrollSubscribeCompanyPage(scrollMyBriefingPageList);
              this.setCheckCallApiCompanyBP(false);
            }
          }
        })
        .catch(err => {
          const scrollMyBriefingPageList = { currentPage: page, loadMore: true };
          this.setScrollSubscribeCompanyPage(scrollMyBriefingPageList);
          this.setCheckCallApiCompanyBP(true);
        });
    }
  }

  async getSocialBriefingPageBySize(page?: number, size?: number) {
    if (this.$store.getters?.userIdentity?.id && this.getScrollSubscribeBriefingPage.loadMore) {
      await this.briefingService()
        .getSubscribeBriefingPage(null, null, null, page, size)
        .then(res => {
          if (res.data?.statusCodeValue == 200) {
            const totalSocialBriefingPages = res.data?.body?.body.totalBriefingPages;
            if (res.data?.body?.body?.socialBriefingPageList && res.data?.body?.body?.socialBriefingPageList.length > 0) {
              const socialBriefingPages = res.data?.body?.body?.socialBriefingPageList;
              socialBriefingPages.forEach(item => {
                item.bpType = 'SOCIAL_BRIEFING';
              });
              this.socialBriefingPages = socialBriefingPages;

              this.setSocialPages(this.socialBriefingPages);
              this.setTotalSubscribeBriefing(totalSocialBriefingPages);
              this.setCheckCallApiSubBP(true);
            } else {
              this.setTotalSubscribeBriefing(totalSocialBriefingPages);
              this.setCheckCallApiSubBP(false);
            }
            // const selected = socialBriefingPages.find(item => item.bpId === this.$route.params.bpId);
            // if (selected) {
            //   this.setSelectedSocialPage(selected);
            // }
          }
        })
        .catch(err => {
          this.setCheckCallApiSubBP(true);
        });
    }
  }

  async getSelectedBriefingPageByBpId(bpId: string) {
    if (this.$store.getters.userIdentity.id) {
      await this.briefingService()
        .getAllBriefingPage(this.$store.getters.userIdentity.id, false, bpId, null, null)
        .then(res => {
          if (res.data?.body?.briefingPageList) {
            this.selectedByUrl = res.data?.body?.briefingPageList[0];
            // const privacy = this.selectedByUrl.privacy == 'PUBLIC';
            this.setChatSetting(this.selectedByUrl.chatSetting);
            this.checkUser = this.selectedByUrl.userProfile.userKey === this.$store.getters.userIdentity.id;
            const bpType = this.selectedByUrl.bpType === 'BRIEFING_PAGE';
            if (this.checkUser && bpType) {
              this.setSelectedBriefingPage(this.selectedByUrl);
            }
          }
        })
        .catch(reason => {
          return;
        });
    }
  }

  async getSelectedSocialPageByBpId(bpId: string) {
    if (this.$store.getters.userIdentity.id) {
      await this.briefingService()
        .getSubscribeBriefingPage(bpId, null, null, null, null)
        .then(res => {
          if (res.data?.body?.body?.socialBriefingPageList && res.data?.body?.body?.socialBriefingPageList.length > 0) {
            const selectedByUrl = res.data?.body?.body?.socialBriefingPageList[0];
            const privacy = selectedByUrl.privacy == 'PUBLIC';
            const subscribe = selectedByUrl.subscribeStatus === 'SUBSCRIBE';
            //getCheckScopeBriefingPage
            if (privacy && subscribe) {
              const selectedPage =
                this.getCheckScopeBriefingPage === this.socialBriefingPageCheck
                  ? ({ ...selectedByUrl, bpType: 'SOCIAL_BRIEFING' } as IBriefingPage)
                  : selectedByUrl;
              this.setSelectedSocialPage(selectedPage);
            }
          }
        })
        .catch(reason => {
          return;
        });
    }
  }

  @Watch('$store.getters.userIdentity.id')
  onWatchUserIdentityIdChange(userKey: string) {
    if (userKey != null || String.prototype.isNullOrEmpty(userKey)) {
      this.subscribeBriefingTitle(userKey);
      this.subscribeBriefingRecommendation(userKey);
    }
  }

  subscribeBriefingRecommendation(userKey: string): void {
    /* subscribe for real-time append briefing recommendation */
    if (this.briefingRecommendationSubscription) {
      this.briefingRecommendationSubscription.unsubscribe();
    }
    this.briefingRecommendationSubscription = this.websocketService().subscribeBriefingRecommendation(userKey, {
      next: (data: any[]) => {
        // for (const item of data) {
        //   this.getRecommendationPages.unshift(this.mapper2BriefingPage(item));
        const recommendationPages = data;
        recommendationPages.forEach(item => (item.bpType = 'RECOMMENDATION_BRIEFING'));
        this.setRecommendationPages(recommendationPages);
        // }
      },
    });
  }

  getBriefingPageRecommendationList() {
    this.loadingGetRecommendations = true;
    // const briefingPageRecommendationList = [];
    try {
      const response = this.briefingService().callApiGetBriefingPageRecommendationList();
      if (response) {
        response.then(res => {
          if (res?.data && res?.status === 200 && res?.data?.body && res?.data?.body?.body && res?.data?.body?.body?.recommendationList) {
            const items = res.data.body.body.recommendationList;
            // for (const item of items) {
            const briefingPageRecommendationList = items;
            briefingPageRecommendationList.forEach(item => (item.bpType = 'RECOMMENDATION_BRIEFING'));
            const selected = briefingPageRecommendationList.find(item => item.bpId === this.$route.params.bpId);
            if (selected) {
              this.setSelectedBriefingPage(selected);
            }
            this.setRecommendationPages(briefingPageRecommendationList);
            // }
          }
        });
      }
    } catch (e) {
      // todo
    } finally {
      this.loadingGetRecommendations = false;
    }
  }

  mapper2BriefingPage(item: any): IBriefingPage {
    return {
      ...item,
      bpType: 'RECOMMENDATION_BRIEFING',
    };
  }

  tempSliceDateTime(inputDateTime: string) {
    return inputDateTime.slice(0, 10);
  }

  //#endregion

  onImageError(event) {
    if (event.target.parentElement) {
      event.target.parentElement.style.display = 'none';
    }
  }

  async handlePinBriefing(bpId, isPin) {
    this.$forceUpdate();
    await this.updatePinBriefing({ bpId, isPin });
  }

  // openPopupCreateNewBriefing() {
  //   this.setShowCreateBriefing(true);
  // }

  handleShowSuccessNotification() {
    // this.showResponseMessage('Update Briefing Success!', 'Success', 'success', 5000);
    this.showResponseMessage(`${this.$t('toast.update.success')}`, `${this.$t('toast.title.success')}`, 'success', 5000);
    this.setIsShowSuccessUpdateBriefing(false);
    this.setIsShowUpdateBriefing(false);
    this.setSelectedUpdatingBriefingPage({});
  }

  showResponseMessage(mess, title, variant, hideDelay) {
    this.$bvToast.toast(mess, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: hideDelay,
    });
  }

  getImageSrc(imageUri, index) {
    const uniqueQuery = Date.now();
    return `${imageUri}?v=${index + Math.random()}`;
  }

  refreshDOM() {
    this.$forceUpdate();
  }

  viewLessBriefingPages() {
    this.indexShowMyBriefingPage = 3;
  }

  changeIsFullRecommendContent(status: boolean) {
    this.isFullRecommendPages = status;
  }

  setSelectedAllBriefingPage() {
    this.setSelectedBriefingPage({});
    this.briefingPages = this.briefingPages.filter(item => item?.bpId !== this.selectedByUrl?.bpId);
    this.indexShow = 5;
    this.selectedByUrl = null;
  }

  setSelectedAllSocialPage() {
    this.setSelectedSocialPage({});
    this.socialBriefingPages = this.socialBriefingPages.filter(item => item?.bpId !== this.selectedByUrl?.bpId);
    this.indexShowSocial = 5;
    this.selectedByUrl = null;
  }

  setSelectedAllCompanyPage() {
    this.setSelectedSocialPage({});
    this.companyBriefingPages = this.companyBriefingPages.filter(item => item?.bpId !== this.selectedByUrl?.bpId);
    this.indexShowCompany = 5;
    this.selectedByUrl = null;
  }

  handleOpenPopupAddBriefingForNewBriefing() {
    this.setIsForNewBriefing(true);
    this.setReferenceDocumentsForNewBriefing([]);
    this.setShowAddReference(true);
  }

  showLessBriefingSocialPages() {
    this.indexShowSocial = 5;
    this.isFullSocialPages = false;
  }

  async loadMoreBriefingSocialPages() {
    if (this.socialBriefingPages.length < this.getTotalSubscribeBriefing) {
      if (this.indexShowSocial < this.socialBriefingPages.length) {
        this.indexShowSocial = this.socialBriefingPages.length;
      } else {
        this.setCheckCallApiSubBP(false);
        await this.getAllSocialBriefingPage(++this.getScrollSubscribeBriefingPage.currentPage);
        this.indexShowSocial = this.socialBriefingPages.length;
      }
    } else {
      this.indexShowSocial = this.socialBriefingPages.length;
    }
    this.isFullSocialPages = this.socialBriefingPages.length >= this.getTotalSubscribeBriefing;
  }

  getFeaturedBriefing() {
    this.loadingGetFeaturedBriefing = true;
    const contentLanguage = this.localStorageUser?.contentLanguages;
    try {
      const response = this.briefingService().getAllFeaturedBriefings(this.tempUserKey, contentLanguage);

      if (response) {
        response.then(res => {
          if (res?.data?.body?.recommendationList) {
            const featuredBriefing = res?.data?.body?.recommendationList;
            featuredBriefing.forEach(item => {
              item.bpType = 'SOCIAL_BRIEFING';
            });
            this.setFeaturedPages(featuredBriefing);
          }
        });
      }

      // fake data
    } catch (e) {
      // todo
    } finally {
      this.loadingGetFeaturedBriefing = false;
    }
  }

  showLessCompanyAgentPages() {
    this.indexShowCompany = 5;
    this.isFullCompanyAgent = false;
  }

  async loadMoreCompanyAgentPages() {
    if (this.companyBriefingPages.length < this.getTotalSubscribeCompany) {
      if (this.indexShowCompany < this.companyBriefingPages.length) {
        this.indexShowCompany = this.companyBriefingPages.length;
        // console.log(this.indexShowCompany)
      } else {
        this.setCheckCallApiCompanyBP(false);
        await this.getAllCompanyAgent(++this.getScrollSubscribeCompanyPage.currentPage);
        this.indexShowCompany = this.companyBriefingPages.length;
      }
    } else {
      this.indexShowCompany = this.companyBriefingPages.length;
    }
    this.isFullCompanyAgent = this.companyBriefingPages.length >= this.getTotalSubscribeCompany;
    console.log(
      `this.isFullSocialPages: ${this.isFullCompanyAgent} - indexShowSocial < getTotalSubscribeBriefing: ${this.indexShowCompany} < ${this.getTotalSubscribeCompany}`
    );
  }

  async changeRouteWithBpId() {
    if (this.$route.params.bpId && this.$route.params.bpId !== 'undefine') {
      if (this.$route.name === 'MyBriefing-All' || this.$route.name === 'MyBriefing-Detail') {
        await this.getSelectedBriefingPageByBpId(this.$route.params.bpId);
      } else if (this.$route.name === 'SocialBriefing-All' || this.$route.name === 'SocialBriefing-Detail') {
        await this.getSelectedSocialPageByBpId(this.$route.params.bpId);
      }
    }
  }

  getDailyWeeklyThumbnail() {
    if (this.tempUserKey) {
      this.briefingService()
        .getDailyWeeklyThumbnail(this.tempUserKey)
        .then(res => {
          if (res.data?.body?.body?.briefingPageList && res.data?.body?.body?.briefingPageList.length > 0) {
            const briefingPageList = res.data?.body?.body?.briefingPageList;
            briefingPageList.forEach(item => {
              if (item.bpType === 'WEEKLY_RECAP') {
                this.weeklyThumbnail = item;
                this.setWeeklyBriefingAgent(this.weeklyThumbnail);
              } else if (item.bpType === 'DAILY_RECAP') {
                this.dailyThumbnail = item;
                this.setDailyBriefingAgent(this.dailyThumbnail);
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  getNewestRecap() {
    if (this.tempUserKey) {
      const dates = [];
      for (let i = 0; i < 7; i++) {
        dates.push(moment(new Date()).subtract(i, 'days').format('yyyy-MM-DD'));
      }
      this.recapService()
        .callApiGetRecapByDate(this.tempUserKey, dates)
        .then(res => {
          if (res?.data?.success && res?.data?.body?.listBriefingData?.length > 0) {
            this.setNewestRecap(res?.data?.body?.listBriefingData[0]);
          }
        });
    }
  }

  toggleAgents() {
    // Toggle the local state; Bootstrap collapse will animate the panel.
    this.isAgentsCollapsed = !this.isAgentsCollapsed;
  }

  toggleSocials() {
    // Toggle the local state; Bootstrap collapse will animate the panel.
    this.isSocialCollapsed = !this.isSocialCollapsed;
  }

  toggleCompanies() {
    // Toggle the local state; Bootstrap collapse will animate the panel.
    this.isCompanyCollapsed = !this.isCompanyCollapsed;
  }
}
